function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AppTile } from '@shared/containers/appTile';
import { Constants } from '@shared/utils/constants';
import SpzaComponent from '@shared/components/spzaComponent';
import { ServiceTile } from '@shared/containers/serviceTile';
class CommonTile extends SpzaComponent {
    renderImpl() {
        if (this.props.entityType === Constants.EntityType.Service) {
            return /*#__PURE__*/ _jsx(ServiceTile, _object_spread({}, this.props));
        }
        return /*#__PURE__*/ _jsx(AppTile, _object_spread({}, this.props));
    }
}
export { CommonTile as default };
